import type { ApartmentSummary, BookingSummary } from "@apartos/contracts";

type StayRange = Pick<BookingSummary, "id" | "apartmentNumber" | "checkInAt" | "checkOutAt" | "status">;

export function bookingOverlapsRange(booking: StayRange, checkIn: string, checkOut: string): boolean {
  if (["cancelled", "no_show", "checked_out"].includes(booking.status)) return false;
  return booking.checkInAt.slice(0, 10) < checkOut && booking.checkOutAt.slice(0, 10) > checkIn;
}

export function apartmentIsAvailableForStay(
  apartmentNumber: string,
  checkIn: string,
  checkOut: string,
  bookings: StayRange[],
  ignoreBookingIds: string[] = [],
): boolean {
  if (!checkIn || !checkOut || checkOut <= checkIn) return false;
  return !bookings.some((booking) => booking.apartmentNumber === apartmentNumber
    && !ignoreBookingIds.includes(booking.id)
    && bookingOverlapsRange(booking, checkIn, checkOut));
}

export function availableApartmentsForStay(
  apartments: ApartmentSummary[],
  bookings: StayRange[],
  checkIn: string,
  checkOut: string,
  options: { ignoreBookingIds?: string[]; selectedNumbers?: string[]; currentNumber?: string } = {},
): ApartmentSummary[] {
  const selectedNumbers = new Set(options.selectedNumbers ?? []);
  return apartments
    .filter((apartment) => apartment.number === options.currentNumber || !["repair", "blocked"].includes(apartment.status))
    .filter((apartment) => apartment.number === options.currentNumber || !selectedNumbers.has(apartment.number))
    .filter((apartment) => apartmentIsAvailableForStay(
      apartment.number, checkIn, checkOut, bookings, options.ignoreBookingIds,
    ))
    .sort((a, b) => a.number.localeCompare(b.number, undefined, { numeric: true }));
}
